import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBreakpoint } from '../hooks/useBreakpoint';

const CATEGORIES = [
  { name: 'Punjabi Juttis', slug: 'juttis', emoji: '👡', desc: 'Handcrafted footwear' },
  { name: 'Earrings', slug: 'earrings', emoji: '✨', desc: 'Jhumkas & studs' },
  { name: 'Necklaces', slug: 'necklaces', emoji: '📿', desc: 'Layered & statement' },
  { name: 'Bracelets', slug: 'bracelets', emoji: '🌸', desc: 'Bangles & cuffs' },
  { name: 'Rings', slug: 'rings', emoji: '💍', desc: 'Kundan & crystal' },
  { name: 'Potli Bags', slug: 'potli-bags', emoji: '👜', desc: 'Ethnic clutches' },
];

export default function CategorySection() {
  const navigate = useNavigate();
  const { isMobile } = useBreakpoint();

  return (
    <section style={{ padding: isMobile ? '40px 0' : '60px 24px', maxWidth: 1200, margin: '0 auto' }}>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: isMobile ? 26 : 32, color: '#2C2C2C', textAlign: 'center', marginBottom: 8, padding: isMobile ? '0 16px' : 0 }}>
        Shop by Category
      </h2>
      <p style={{ textAlign: 'center', color: '#888', marginBottom: 32, fontSize: 15, padding: isMobile ? '0 16px' : 0 }}>
        Explore our curated collections of ethnic fashion
      </p>

      {/* Horizontal scroll on mobile, centered wrap on desktop */}
      <div
        className={isMobile ? 'category-scroll' : ''}
        style={{
          display: 'flex',
          gap: isMobile ? 12 : 20,
          justifyContent: isMobile ? 'flex-start' : 'center',
          flexWrap: isMobile ? 'nowrap' : 'wrap',
          padding: isMobile ? '4px 16px 12px' : 0,
        }}
      >
        {CATEGORIES.map(cat => (
          <div
            key={cat.slug}
            onClick={() => navigate(`/shop?category=${cat.slug}`)}
            style={{
              background: '#fff',
              border: '2px solid #f0e0e0',
              borderRadius: 12,
              padding: isMobile ? '20px 16px' : '28px 24px',
              textAlign: 'center',
              cursor: 'pointer',
              minWidth: isMobile ? 120 : 160,
              flex: isMobile ? '0 0 auto' : '0 0 auto',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = '#8B1A1A';
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(139,26,26,0.12)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = '#f0e0e0';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{ fontSize: isMobile ? 32 : 40, marginBottom: 10 }}>{cat.emoji}</div>
            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: isMobile ? 14 : 17, color: '#8B1A1A', marginBottom: 4 }}>{cat.name}</h3>
            {!isMobile && <p style={{ fontSize: 12, color: '#999' }}>{cat.desc}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
